module.exports = new __parcel__URL__("blue-icon.c1b280f0.png").toString();